<script setup lang="ts">
defineProps<{
  message: string;
}>();
</script>

<template>
  <p>
    <v-icon
      icon="mdi-information-outline"
      class="mb-1"
    />
  </p>
  <v-tooltip
    activator="parent"
    location="top"
    max-width="300"
    :text="message"
  />
</template>
